module.exports = __webpack_public_path__ + "img/460-57f3f7.png";